<template>
  <div class="block-information localChain clearfix" v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java1.png">
    </div>
    <div class="fl">
      <span class="angle"></span>
      <section class="section1">
        <div class="clearfix" id="Block">
          <!--<div class="phone">
            <div class="block_cont">
              <router-link v-if="down!=0" :to="`/HyperblockView/${down}`" class="prev-block fl">
                <img src="@/../public/static/img/blockView/prev-block.png">
              </router-link>
              <a v-else href="javascript:;" class="prev-block fl disable">
                <img src="@/../public/static/img/blockView/prev-block.png">
              </a>
               <img src="@/../public/static/img/blockView/hyperchainBlockIcon.png" class="fl" style="margin-top:0px;">
              <span class="cont fl" v-text="hyper_block"></span> 
              <router-link :to="`/HyperblockView/${up}`" v-if="up!=0" class="next-block fl">
                <img src="@/../public/static/img/blockView/next-block.png">
              </router-link>
              <a v-else href="javascript:;" class="disable next-block">
                <img src="@/../public/static/img/blockView/next-block.png">
              </a>
            </div>
          </div> -->
          <div class="fl tit">
            <span>{{$t('LocalChainMsg')}}</span>
            <br class="br"/>
            <img 
              class="app_logo" 
              :src="
              app_logo ? app_logo : 
              app_id == -1 ? './img/blockView/icon/hybrid.svg' :
              app_type == 33 ? './img/blockView/icon/coin.svg' :
              app_type == 17 ? './img/blockView/icon/token.svg' : 
              './img/blockView/icon/default.svg'"> 
            <span class="app_name" v-text="app_name"></span>
          </div>
          <div class="fr">
            <router-link v-if="down!=0" :to="`/LocalchainView/${$route.params.hid}/${down}`" class="a" id="prev" v-text="`<${$t('Next')}`">&lt;后一个</router-link>
            <a v-else href="javascript:;" class="a disable" v-text="`<${$t('Next')}`">&lt;后一个</a>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <router-link :to="`/LocalchainView/${$route.params.hid}/${up}`" v-if="up!=0" class="a" id="next" v-text="`${$t('Previous')}>`">前一个&gt;</router-link>
            <a v-else href="javascript:;" class="disable a" v-text="`${$t('Previous')}>`">前一个&gt;</a>
          </div>
          <!-- <div class="help fr" @click="helpBol = true">
            <img src="@/../public/static/img/blockView/help.png" alt="">
          </div> -->
        </div>
        <div class="row clearfix">
          <span class="key" v-text="`${$t('Localchain')}：`">
            
          </span>
          <span class="cont" v-text="`${ $route.params.hid },${ $route.params.chainNum }`">

          </span>
        </div>
        <div class="row clearfix">
          <span class="key" v-text="`${$t('Height')}:`">
            
          </span>
          <span class="cont" v-text="localchain_height">

          </span>
        </div>
        <div class="row clearfix">
          <span class="key" v-text="`${$t('Blocks')}:`">
            
          </span>
          <span class="cont" v-text="blocks">

          </span>
        </div>
        <div class="row clearfix">
          <span class="key" v-text="`${$t('Difficulty')}:`">
            
          </span>
          <span class="cont" v-text="difficulty">

          </span>
        </div>
        <div class="row clearfix">
          <span class="key" v-text="`${$t('Consensus')}:`">
            
          </span>
          <span class="cont" v-text="consensus">

          </span>
        </div>
        <div class="dottedBottom"></div>
      </section>
      <div class="tit" v-text="$t('LocalBlockList')">
        子链区块列表
      </div>
      <section class="section2 clearfix">
        <!-- <span class="chains clearfix">
          <div class="fl">
            <div class="fl block" id="block">
              <span class="cont" v-text="`${ $route.params.hid },${ $route.params.chainNum }`"></span>
              <span class="img"></span>
              <div class="help" @click="helpBol = true">
                <img src="@/../public/static/img/blockView/help.png" alt="">
              </div>
            </div>
            <div class="fl block_chain" id="block_chain">
              <img v-if="block_chain == 'buddy chain'" src="@/../public/static/img/blockView/B.png" alt="icon">
              <img v-else src="@/../public/static/img/blockView/weizhi.png" alt="icon">
              <span class="key" v-text="block_chain"></span>
            </div>
          </div>
          <div class="fr bg2 localChainView">
            <div class="fl height" id="height">
              <span class="hexagon">H</span>
              <span class="cont" v-text="localchain_height"></span>
              <span class="key" v-text="$t('Height')">高度</span>
            </div>
            <div class="fl blocks" id="blocks">
              <span class="hexagon">B</span>
              <span class="cont" v-text="blocks"></span>
              <span class="key" v-text="$t('Blocks')">区块数</span>
            </div>
            <div class="fl difficulty" id="difficulty">
              <span class="hexagon">D</span>
              <span class="cont" v-text="difficulty"></span>
              <span class="key" v-text="$t('Difficulty')">难度</span>
            </div>
            <div class="fl concensus" id="concensus">
              <span class="hexagon">C</span>
              <span class="cont" v-text="concensus"></span>
              <span class="key" v-text="$t('Concensus')">共识算法</span>
            </div>
          </div>
        </span> -->
        <div class="localBlocks clearfix" id="tab">
          <div>
            <table class="table">
              <tr>
                <th v-text="$t('LocalBlock')"></th>
                <th v-text="$t('BlockSize')"></th>
                <th v-text="$t('BlockVersion')"></th>
                <th v-text="$t('Difficulty')"></th>
                <th v-text="$t('Time')"></th>
                <!-- <th v-text="$t('DApp')"></th> -->
                <th v-text="$t('PayloadSize')"></th>
              </tr>
              <tr 
              v-for="(item,index) in hyperblocks"
              :key="index"
              @click="$router.push(`/LocalBlockView/${ item.hid }/${ item.chain_num }/${ item.id }`)">
                <td>
                  <a href="javascript:;" v-text="`${ item.hid },${ item.chain_num },${ item.id }`"></a>
                  <!-- <router-link :to="`/LocalBlockView/${ item.hid }/${ item.chain_num }/${ item.id }`" v-text="`${ item.hid },${ item.chain_num },${ item.id }`">
                  </router-link> -->
                </td>
                <td>{{item.block_size}}</td>
                <td>{{item.ver}}</td>
                <td>{{item.difficulty}}</td>
                <td>{{$retTime(item.time*1000)}}</td>
                <!-- <td>{{item.app}}</td> -->
                <td>{{`${item.payload_size}`}}</td>
              </tr>
            </table>
          </div>
          <!-- <router-link
            v-for="(item,index) in hyperblocks"
            :to="`/LocalBlockView/${ item.hid }/${ item.chain_num }/${ item.id }`"
            :key="index"
            class="box localChainView" style="width: 100%;margin: 14px 0;">
            <div class="fl clearfix block">
              <div class="fl img"></div>
              <div class="fl">
                <div class="blocks" v-text="`${ item.hid },${ item.chain_num },${ item.id }`"></div>
                <span class="key" v-text="`${$t('Size')}:`">块大小:</span>
                <span class="cont" v-text="item.block_size"></span>
                <span class="key" v-text="`${$t('Ver')}:`">版本:</span>
                <span class="cont" v-text="item.ver"></span>
                <div class="clearfix fl">
                  <span class="key" v-text="`${$t('Difficulty')}:`">难度:</span>
                  <span class="cont" v-text="item.difficulty"></span>
                </div>
                <div class="clearfix fl"><span class="key" v-text="$retTime(item.time*1000)"></span></div>
              </div>
            </div>
            <div class="fr paload bg2 clearfix">
              <div class="fl img"></div>
              <div class="fl">
                <div class="blocks" v-text="$t('Payload')">区块负载</div>
                <span class="key" v-text="item.app"></span>
                <span class="key" v-text="`${item.payload_size}KB`"></span>
              </div>
            </div>
          </router-link> -->
        </div>
      </section>
      <pages 
        toLink="LocalchainView" 
        :pageCount="pageCount" 
        :hid="$route.params.hid"
        :chainNum="$route.params.chainNum"
        :page="page">
      </pages>
    </div>
    <!-- <help v-show="helpBol" @close="close" /> -->
  </div>
</template>
<script>
import help from '@/components/help.vue'
import pages from '@/components/pages.vue'
export default {
  data() {
    return {
      block_chain: 0,
      blocks: 0,
      localchain_height: 0,
      difficulty: 0,
      consensus: 0,
      down: 0,
      up: 0,
      hyperblocks: [],
      helpBol: false,
      pageCount: 0,
      page: 0,
      app_name: '',
      app_logo: '',
      app_type: '',
      app_id: 0,
      loading: true,
    }
  },
  components:{
    help,pages
  },
  created(){
    this.init();
  },
  watch: {
    $route(){
      this.init();
    }
  },
  methods: {
     init(){
      this.$http({
        url:`hyperchain/localchain?hid=${ this.$route.params.hid }&chain_num=${ this.$route.params.chainNum }&page=${ this.$route.params.page }&pageSize=24`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.ret == 200){
          this.loading = false;
          this.block_chain = data.data.info.block_chain
          this.blocks = data.data.info.blocks
          this.localchain_height = data.data.info.localchain_height
          this.difficulty = data.data.info.difficulty
          this.consensus = data.data.info.concensus
          this.app_name = data.data.info.app_name;
          this.app_logo = data.data.info.app_logo;
          this.app_type = data.data.info.app_type;
          this.app_id = data.data.info.app_id;
          this.up = data.data.info.up
          this.down = data.data.info.down
          this.hyperblocks = data.data.data;
          this.pageCount = data.data.pages.pageCount;
          if(data.data.pages.page<1){
            this.page = 1;
          }else{
            this.page = data.data.pages.page;
          }
        }
      })
    },
    close(){
      this.helpBol = false;
    }
  }
}
</script>
<style lang="scss" scoped>
  .table{
    table-layout: auto;
  }
  .localBlocks{
    &>div{
      width: 100%;
    }
  }
</style>
